declare let SEARCH_CONFIG: Record<string, any> | undefined;
declare let MEDIA_URL: string | undefined;

export const configGlobal =
  typeof SEARCH_CONFIG !== 'undefined'
    ? SEARCH_CONFIG
    : {
        product: {
          context: 'catalog',
          siteId: 'materialbank_product',
          siteUrl: 'https://search.materialbank.com/v2',
        },
      };

export const searchApiURL =
  configGlobal?.product?.siteUrl?.replace(/\/$/, '') ||
  'https://searchdev.materialbank.com/v2';

export const mediaUrlGlobal =
  typeof MEDIA_URL !== 'undefined'
    ? MEDIA_URL?.replace(/\/$/, '')
    : 'https://materialbank-uat2-cdn.global.ssl.fastly.net/media';

export const apiURLv1 = '/rest/V1';
export const apiURLv2 = '/rest/V2/sdg-api';

export const config = {
  boardsMediaUrl: `${mediaUrlGlobal}/catalog/product`,
};
